module.exports = __webpack_public_path__ + "img/83.disposable_dishes.d4125d56.svg";